import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EntryComponent } from './entry/entry.component';
import { LoginComponent } from './login/login.component';
import { AccountPasswordComponent } from './account-password/account-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ClientSelectorComponent } from './client-selector/client-selector.component';
import { KeplerMatchSelectorComponent } from './kepler-match-selector/kepler-match-selector.component';
import { MarsGroupSelectorComponent } from './mars-group-selector/mars-group-selector.component';
import { OtpComponent } from './otp/otp.component';
import { ProfileGuard } from '@core/guards/profile/profile.guard';

const loginRoutes: Routes = [
  { path: 'entry', title: 'authEntry', component: EntryComponent },
  { path: 'login', title: 'authLogin', component: LoginComponent },
  { path: 'client-selector', title: 'authClientSelector', component: ClientSelectorComponent },
  {
    path: 'kepler-match-selector',
    title: 'authKeplerMatch',
    component: KeplerMatchSelectorComponent
  },
  {
    path: 'mars-group-selector',
    title: 'authMarsGroup',
    component: MarsGroupSelectorComponent
  },
  {
    path: 'account/activate',
    title: 'authAccountActivate',
    component: AccountPasswordComponent,
    data: { title: 'auth.activateAccount', operation: 'activation' }
  },
  {
    path: 'account/reset',
    title: 'authAccountReset',
    component: AccountPasswordComponent,
    data: { title: 'auth.changePassword', operation: 'reset' }
  },
  { path: 'forgot-password', title: 'authForgotPass', component: ForgotPasswordComponent },
  { path: 'otp', title: 'authOtp', component: OtpComponent, canActivate: [ProfileGuard] }
];

/**
 * Routing for the authentication module: login, account activation/reset,
 * match/group selectors, and OTP verification after a two-factor login.
 */
@NgModule({
  imports: [RouterModule.forChild(loginRoutes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthRoutingModule {}
